function config () {
  return ({
    api: {
      url: 'https://api.mikulas.rudickamladez.cz/'
    }
  })
}

export default config()
